<template>
  <div class="page">
    <!-- 头部显示标题 时间  -->
    <div class="mytop">
      {{ detail.title }}
    </div>
    <div class="top">
      <div class="topLeft">
        <div class="topLeftOne">
          <div>
            {{ detail.created_at }}
          </div>
        </div>
        <!-- <div
          class="cententForChilImgBoxListDz"
          @click.stop="goLike(detail)"
          v-if="detail.shadow_game_type.is_excellent !== 1"
        >
          <div class="cententForChilImgBoxListDzImg">
            <img
              style="cursor: pointer;"
              v-if="detail.is_like"
              src="@/assets/ydz.png"
            />
            <img style="cursor: pointer;" v-else src="@/assets/wdz1.png" />
          </div>
          <div class="cententForChilImgBoxListDzNum">
            {{ detail.like_num || 0 }}
          </div>
        </div> -->
        <!-- 是否投票 -->
        <!-- <div
          class="cententForChilImgBoxListDz"
          @click.stop="goVote(detail)"
          v-if="
            detail.shadow_game_type.is_excellent !== 1 &&
              detail.is_open_vote != 0
          "
        >
          <div class="cententForChilImgBoxListDzImg">
            <img
              style="cursor: pointer;"
              v-if="detail.is_vote"
              src="@/assets/ytp.png"
            />
            <img style="cursor: pointer;" v-else src="@/assets/wtp1.png" />
          </div>
          <div class="cententForChilImgBoxListDzNum">
            {{ detail.vote_num || 0 }}
          </div>
        </div> -->
      </div>
      <div class="topRight">
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>
    <!-- 中间 显示图片 -->
    <div class="centent">
      <el-row :gutter="10">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
          <!-- 大图 -->
          <div class="cententLeft">
            <div class="cententLeftImg">
              <img :src="row.url" />
            </div>
            <!-- <div class="cententLeftWz" v-if="row.desc||row.title">
							<div>
								{{row.title}}
							</div>
							<div v-if="row.desc">
								{{row.desc}}
							</div>
						</div> -->
          </div>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="cententRight">
            <div class="cententRightUp">
              <div @click="goUp()">
                <i class="el-icon-arrow-up"></i>
              </div>
            </div>
            <div class="cententRightBox">
              <div
                v-for="(item, indexa) in detail.photos"
                @click="goItem(item, indexa)"
              >
                <img
                  :src="item.url"
                  :class="indexa == index ? 'cententRightBoxXz' : ''"
                  :style="{
                    height: isMobile ? '68px' : '200px',
                  }"
                />
              </div>
            </div>
            <div class="cententRightBoxNext">
              <div @click="goNext()">
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 底部显示当前图库信息-->
    <div class="bottom">
      <el-form label-width="80px">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12">
            <el-form-item label="作品名称" v-if="detail.title"
              >{{ detail.title }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="学校" v-if="detail.school"
              >{{ detail.school }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="专业" v-if="detail.speciality"
              >{{ detail.speciality }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="姓名" v-if="detail.name"
              >{{ detail.name }}
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
						<el-form-item label="联系方式" v-if="detail.phone">{{detail.phone}}
						</el-form-item>
					</el-col> -->
          <el-col :xs="24" :sm="12">
            <el-form-item label="作品描述" v-if="detail.desc"
              >{{ detail.desc }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="作品信息" v-if="detail.info"
              >{{ detail.info }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="通讯地址" v-if="detail.address"
              >{{ detail.address }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24">
            <el-form-item label="导师点评" v-if="detail.comment"
              >
			  <div style="white-space: pre-line;">
				  {{ detail.comment }}
			  </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <el-descriptions :labelStyle="{
				color:'#fff'
			}" :contentStyle="{
				color:'#fff'
			}">
					<el-descriptions-item label="作品名称" v-if="detail.title">{{detail.title}}</el-descriptions-item>
					<el-descriptions-item label="学校" v-if="detail.school">{{detail.school}}</el-descriptions-item>
					<el-descriptions-item label="专业"
						v-if="detail.speciality">{{detail.speciality}}</el-descriptions-item>
					<el-descriptions-item label="姓名" v-if="detail.name">{{detail.name}}</el-descriptions-item>
					<el-descriptions-item label="联系方式" v-if="detail.phone">{{detail.phone}}</el-descriptions-item>
					<el-descriptions-item label="作品描述" v-if="detail.desc">{{detail.desc}}</el-descriptions-item>
					<el-descriptions-item label="作品信息" v-if="detail.info">{{detail.info}}</el-descriptions-item>
					<el-descriptions-item label="通讯地址" v-if="detail.address">{{detail.address}}</el-descriptions-item>
				</el-descriptions> -->
    </div>
  </div>
</template>

<script>
import {
  shadow_game_album_photo_api,
  shadow_game_album_dz_api,
  shadow_game_album_vote_api,
} from "@/api/index.js";
export default {
  components: {},
  data() {
    return {
      id: "",
      detail: {
        shadow_game_type: {},
      },
      row: {},
      index: 0,
    };
  },
  mounted() {
    this.index = 0;
    this.row = {};
    this.id = this.$route.query.id
    this.getDetail();
  },
  methods: {
    getDetail() {
      let data = {
        shadow_game_album_id: this.id,
      };
      const loading = this.$loading({
        lock: true,
      });
      shadow_game_album_photo_api(data)
        .then((res) => {
          console.log(res);
          this.detail = res.data;
          this.row = res.data.photos[this.index];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    goLike(e) {
      let data = {
        shadow_game_album_id: e.id,
      };
      const loading = this.$loading({
        lock: true,
      });
      shadow_game_album_dz_api(data)
        .then((res) => {
          console.log(res);
          e.is_like = !e.is_like;
          if (e.is_like) {
            e.like_num++;
          } else {
            e.like_num--;
          }
          this.$message.success(res.msg);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    goVote(e) {
      let data = {
        shadow_game_album_id: e.id,
      };
      const loading = this.$loading({
        lock: true,
      });
      shadow_game_album_vote_api(data)
        .then((res) => {
          
           if(res.code==200) {
             e.is_vote = true
            e.vote_num++
          }
          // e.is_vote = !e.is_vote;
          // if (e.is_vote) {
          //   e.vote_num++;
          // } else {
          //   e.vote_num--;
          // }
          this.$message.success(res.msg);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    goBack() {
      // window.close();
     this.$router.go(-1);
    },
    goItem(item, index) {
      this.row = item;
      this.index = index;
    },
    goUp() {
      if (this.index !== 0) {
        this.index--;
      } else {
        this.index = this.detail.photos.length - 1;
      }
      this.row = this.detail.photos[this.index];
    },
    goNext() {
      if (this.index !== this.detail.photos.length - 1) {
        this.index++;
      } else {
        this.index = 0;
      }
      this.row = this.detail.photos[this.index];
    },
  },
};
</script>

<style></style>
<style scoped lang="scss">
::v-deep {
  .el-form-item__label {
    color: #fff;
  }
  .el-form-item__content {
    color: #fff;
  }
}

.mytop {
  padding: 20px 20px 0 20px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  color: #fff;
  font-size: 22px;
}

.page {
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #262626;
  min-height: 100vh;
  .top {
    padding: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    color: #fff;

    .topLeft {
      display: flex;
      align-items: center;

      .topLeftOne {
        display: flex;
        align-items: center;
        > div:nth-of-type(1) {
          // margin-bottom: 10px;
        }
      }

      .cententForChilImgBoxListDz {
        display: flex;
        padding: 0 20px;
        box-sizing: border-box;
        // margin-top: 15px;

        .cententForChilImgBoxListTil {
          flex: 1;
        }

        .cententForChilImgBoxListDzImg {
          display: flex;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
          }
        }

        .cententForChilImgBoxListDzNum {
          // font-size: 14px;
          margin-left: 10px;
        }
      }
    }
  }
}

.centent {
  max-width: 1200px;
  margin: 20px auto 0;

  .cententLeft {
    .cententLeftImg {
      width: 100%;
      display: flex;
      justify-content: center;

      img {
        width: 100%;
        object-fit: cover;
      }
    }

    .cententLeftWz {
      color: #fff;

      > div {
        word-break: break-all;
        word-wrap: break-word;
        margin-top: 10px;
      }
    }
  }

  .cententRight {
    .cententRightUp {
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        border-radius: 100%;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        margin-bottom: 20px;

        i {
          font-size: 28px;
        }
      }
    }

    .cententRightBoxNext {
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        border-radius: 100%;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        margin-top: 20px;

        i {
          font-size: 28px;
        }
      }
    }

    .cententRightBox {
      // max-height: 600px;
      // overflow-y: auto;

      .cententRightBoxXz {
        border: 1px solid #fff;
        box-sizing: border-box;
      }

      img {
        // height: 200px;
        border-radius: 10px;
        width: 100%;

        object-fit: cover;
        margin-bottom: 10px;
        cursor: pointer;
      }

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-track {
        --webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        // background: rgb(128, 128, 128);
        background: rgb(38, 193, 130);
        --webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.3);
      }

      &::-webkit-scrollbar-thumb:window-inactive {
        background: rgba(255, 255, 255, 0.3);
        border-radius: 10px;
      }
    }
  }
}

.bottom {
  border-top: 1px solid #fff;
  padding: 20px 0;
  max-width: 1200px;
  margin: 20px auto 0;
}
</style>
